import React from "react";
import { cn } from "./cn";

/**
 * Etiqueta de estado. Fondo suave + texto saturado en vez de píldoras sólidas:
 * comunica el estado sin competir con los datos de la fila.
 */
export type BadgeTone =
  | "neutral"
  | "brand"
  | "success"
  | "warning"
  | "danger";

const tones: Record<BadgeTone, string> = {
  neutral:
    "border-gray-200 bg-gray-50 text-gray-700 dark:border-white/10 dark:bg-white/5 dark:text-gray-200",
  brand:
    "border-brand-100 bg-brand-50 text-brand-700 dark:border-white/10 dark:bg-brand-500/15 dark:text-brand-200",
  success:
    "border-green-200 bg-green-100 text-green-800 dark:border-green-600/30 dark:bg-green-700/20 dark:text-green-300",
  warning:
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/15 dark:text-amber-300",
  danger:
    "border-red-200 bg-red-100 text-red-700 dark:border-red-500/30 dark:bg-red-600/15 dark:text-red-300",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  icon?: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  tone = "neutral",
  icon,
  className,
  children,
  ...rest
}) => (
  <span
    className={cn(
      "inline-flex select-none items-center gap-1.5 rounded-full border px-2.5 py-1",
      "text-[12px] font-semibold leading-none",
      tones[tone],
      className
    )}
    {...rest}
  >
    {icon ? <span className="flex text-[13px]">{icon}</span> : null}
    {children}
  </span>
);

export default Badge;
